import {evaluateFunction} from "@wix/devzai-utils-common";


function runAfterDomLoaded<R>(func:() => R) {
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", function() {
            evaluateFunction(func)
        });
    } else {
        evaluateFunction(func)
    }
}
export function doppeWowAppClientBootstrap () {
    runAfterDomLoaded(() => {
        evaluateFunction(async () => {
            (await import('./doppe-wow-app-demo')).doppeWowAppDemo();
        })
            .catch((error) => {
                console.error(`doppeWowAppClientBootstrap failed`, error)
            })
    })
}
